const styles = (theme) => ({
    progress: {
        margin: theme.spacing(1),
    },
    // styles based on type
    default: {
        alignSelf: "center",
    },
    // other?
});

export default styles;
